<template>
<div class="product-list" v-if="site_data && site_data.result">
    <div class="notification" v-if="site_data.result.list.length == 0">
        <p class="title is-2">No product found</p>
    </div>
    <template v-else>
        <div class="product-list__header columns is-mobile">
            <div class="column">
                <button @click.prevent="view_type = 'grid'" :class="['product-list__header__button switch-grid', { 'is-active': view_type == 'grid'}]"><i class="fas fa-th-large"></i></button>
                <button @click.prevent="view_type = 'row'" :class="['product-list__header__button switch-row', { 'is-active': view_type == 'row'}]"><i class="fas fa-bars"></i></button>
                <span>There <template v-if="site_data.result.total > 1">are</template><template v-else>is</template> <strong>{{site_data.result.total}}</strong> product<template v-if="site_data.result.total > 1">s</template></span>
            </div>
            <div class="column is-narrow select-label"><strong>sort by:</strong></div>
            <div class="column is-narrow">
                <div class="select">
                    <select v-model="sort_order">
                        <option value="n:a-z">Name, A to Z</option>
                        <option value="n:z-a">Name, Z to A</option>
                        <option value="p:l-h">Price, low to high</option>
                        <option value="p:h-l">Price, high to low</option>
                    </select>
                </div>
            </div>
        </div>
        <div v-if="view_type == 'grid'" class="product-list__list columns is-variable is-4 is-multiline is-mobile">
            <ProductTile :class="'column is-' + col_size" :product="item" :key="i" v-for="item, i in site_data.result.list" />
        </div>
        <div v-else class="product-list__list">
            <ProductItem :product="item" :key="i" v-for="item, i in site_data.result.list" />
        </div>
        <nav v-if="site_data && site_data.result && site_data.result.list.length > 0 && site_data.result.pages > 1" class="pagination product-list__pagination" role="navigation" aria-label="pagination">
            <router-link :to="{ path: $route.path, query: query_maker(page - 1) }" v-if="page - 1 >= 0" class="pagination-nav pagination-previous">Prev</router-link>
            <a v-else disabled="disabled" class="pagination-nav pagination-previous">Prev</a>
            <router-link v-if="page + 1 < site_data.result.pages" class="pagination-nav pagination-next" :to="{ path: $route.path, query: query_maker(page + 1) }">Next</router-link>
            <a v-else disabled="disabled" class="pagination-nav pagination-next">Next</a>
            <ul class="pagination-list">
                <li v-for="item in pagination">
                    <span v-if="item.index == null" class="pagination-ellipsis">&hellip;</span>
                    <router-link v-else :class="['pagination-link', {'is-current': page == item.index}]" :to="{ path: $route.path, query: query_maker(item.index) }">{{item.label}}</router-link>
                </li>
            </ul>
        </nav>
        <p class="has-text-centered has-text-grey" style="font-size: 13px;" v-if="site_data.result.pages == 1">- all products loaded -</p>
    </template>
</div>
</template>

<script>
import ProductTile from '../blocks/elements/ProductTile';
import ProductItem from '../blocks/elements/ProductItem';
import SortingMixin from '../mixins/SortingMixin';
import PaginationMixin from '../mixins/PaginationMixin';
export default {
    name        :   'ProductList',
    components  :   {
        ProductTile,
        ProductItem
    },
    mixins      :   [ PaginationMixin, SortingMixin ],
    data()
    {
        return {
            view_type   :   localStorage.view_type ? localStorage.view_type : 'grid'
        };
    },
    created()
    {
        if (!localStorage.view_type) {
            localStorage.view_type  =   'grid';
        }
    },
    computed    :   {
        site_data()
        {
            return this.$store.state.site_data;
        },
        col_size()
        {
            if (this.$store.state.width <= 600) {
                return 6;
            }

            return 4;
        }
    },
    watch       :   {
        view_type(nv, ov)
        {
            localStorage.view_type  =   nv;
            if (nv == 'grid') {
                this.$nextTick().then(() => {
                    $('.product-tile .title').matchHeight();
                    $(window).resize();
                });
            }
        }
    },
    mounted()
    {
        this.$nextTick().then(() => {
            $('.product-tile .title').matchHeight();
            $(window).resize();
        });
    },
    methods     :   {
        query_maker(page)
        {
            return this.make_query(page, this.$route.name == 'SearchPage');
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/blocks/ProductList.vue